import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
type ProjectCardProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  wordmark: string;
  tagline: string;
  description: string;
  href: string;
  stat?: string;
  statLabel?: string;
  headingLevel?: 'h2' | 'h3' | 'h4';
};
export function ProjectCard({
  wordmark,
  tagline,
  description,
  href,
  stat,
  statLabel,
  headingLevel = 'h3',
  className = '',
  ...rest
}: ProjectCardProps) {
  const Heading = headingLevel;
  return <a href={href} className={`group flex flex-col rounded-2xl border border-hairline bg-[#fbfbfc] p-7 transition-colors duration-200 void-ease hover:border-void/40 hover:bg-void-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-void focus-visible:ring-offset-2 lg:flex-row lg:items-center lg:gap-8 ${className}`} {...rest} data-id="element-66" data-mp="2lj84tn032x8x">
      <div className="lg:w-52 lg:shrink-0" data-id="element-67" data-mp="105lsu5x5bxeg">
        <span className="font-mono text-lg lowercase text-void" data-id="element-68" data-mp="106omgllusdy2">{wordmark}</span>
        {stat && <p className="mt-1 font-mono text-[11px] text-muted" data-id="element-69" data-mp="1hfk9vbc434g">
            <span className="text-ink" data-id="element-70" data-mp="3sn7byz4rfntd">{stat}</span> {statLabel}
          </p>}
      </div>
      <div className="mt-4 flex-1 lg:mt-0" data-id="element-71" data-mp="ah2qcuf0dx3u">
        <Heading className="text-lg font-semibold tracking-tight text-ink" data-id="element-72" data-mp="aivxeatjajcd">{tagline}</Heading>
        <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted" data-id="element-73" data-mp="5hgcqjv9qeui">{description}</p>
      </div>
      <ArrowUpRightIcon aria-hidden="true" className="mt-4 h-5 w-5 shrink-0 text-muted transition-transform duration-150 void-ease group-hover:-translate-y-0.5 group-hover:translate-x-0.5 lg:mt-0" data-id="element-74" data-mp="ke79smhgzegy" />
    </a>;
}